import $ from "jquery";
import Pagetop from "./modules/pagetop";
import Top from "./modules/top";
import HeaderScroll from "./modules/headerScroll";
import NavGlobal from "./modules/navGlobal";
import RoutineScroll from './modules/routineScroll';
import AccdPremior from "./modules/accdPremior";
import PageTopScroll from "./modules/pagetopScroll";
import gnaviCurrent from "./modules/gnaviCurrent";
import DeviceCheck from "./modules/DeviceCheck";
import AnchorLink from "./modules/anchorLink";
import MatchHeight from "./modules/match_height";
import Screen from "./modules/screen";
import { parallax, parallaxScroll } from "./modules/parallax";
import FadeScroll from './modules/fadeScroll';
import OuchiBeauty from './modules/ouchiBeauty';
import JournalSwiper from './modules/journalSwiper'
import BasicSlider from './modules/basicSlider'
import Survey from './modules/survey'
import kvPremior from './modules/kvPremior'
import CommonAccordian from './modules/accordian'

/* ----------------------------------------------------------
  init
---------------------------------------------------------- */
const pagetop = new Pagetop({
  target: ".js-pagetop",
});

const anchorLink = new AnchorLink({
  target: ".js-anchor",
});

const matchHeight = new MatchHeight({
  target: ".js-matchHeight-group",
});

const top = new Top({
  target: "#top",
});

const pagetopscroll = new PageTopScroll({
  target: ".js-pagetop-scroll",
});

const deviceCheck = new DeviceCheck({
  target: "html",
});

const headerscroll = new HeaderScroll({
  target: ".js-header-scroll",
});

const fadeScroll = new FadeScroll({
  target: '.js-fade-scroll'
});
const survey = new Survey();



const ouchiBeauty = new OuchiBeauty();

const navGlobal = new NavGlobal();
const routineScroll = new RoutineScroll();
const accdPremior = new AccdPremior();
const kvpremior = new kvPremior();

const jsJournalSwiper = new JournalSwiper({
  target: '.js-journal-swiper'
});

const commonAccordion = new CommonAccordian({
  target: '.js-cmn-accordian'
});

const jsBasicSlider = new BasicSlider();

top.init();
pagetop.init();
anchorLink.init();
headerscroll.init();
navGlobal.init();
routineScroll.init();
accdPremior.init();
pagetopscroll.init();
deviceCheck.init();
fadeScroll.init();
ouchiBeauty.init();
gnaviCurrent();
parallax();
parallaxScroll();
jsJournalSwiper.init();
survey.initial();
kvpremior.init();
commonAccordion.init();
jsBasicSlider.init();
matchHeight.init();

/* ----------------------------------------------------------
  Screen
---------------------------------------------------------- */
const screen = new Screen();
$(window).on("resize", screen.size());
$(window).on("breakpointChange");